import Button from '@/shared/components/rebranded/Button/Button';
import styled from 'styled-components';
import WomanShrugSVG from '../../../assets/woman-shrug.svg';
import { URLs } from '../../URLs';

type Props = {
  title: string;
  description?: string;
  action?: {
    label: string;
    onAction: () => void;
  };
  withBackButton?: boolean;
};

function AppError({ title, description, action, withBackButton }: Props) {
  return (
    <div
      style={{
        textAlign: 'center',
        marginTop: 100
      }}
    >
      <h1 className="dsm-heading1">{title}</h1>
      <WomanShrugSVG style={{ height: 150, margin: '32px 0' }} />
      <p style={{ marginBottom: 32 }} className="dsm-subtitle1">
        {description}
      </p>

      <Wrapper>
        {action ? (
          <Button onClick={action.onAction} m="8px">
            {action.label}
          </Button>
        ) : (
          <Button as="a" m="8px" href={URLs.STOREBRAND_HOME}>
            Avslutt
          </Button>
        )}
        {withBackButton && (
          <Button
            variant="outlined"
            m="8px"
            onClick={() => window.history.back()}
          >
            Tilbake
          </Button>
        )}
      </Wrapper>
    </div>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export default AppError;
